<template>
  <v-container fluid pt-0 pl-0 pr-0 pb-0 mt-0 style="height: 80vh">
    <v-layout row wrap style="height: 80vh">
      <v-flex md2 d-flex class="" style="height: 80vh">
        <v-layout row wrap>
          <v-flex md12 mt-3 d-flex class="background_doc rounded-tabs-sub">
            <v-card-text>
              <v-row align-top class="tw-txt-color-primary">
                <div class="tamany_titol_sitebar">{{ `documentation.sitebar.title` | t }}</div>
                <br />
                <p>{{ `documentation.sitebar.description` | t }}</p>
                <br />
                <div class="tamany_titol_sitebar">{{ `documentation.sitebar.tips_title` | t }}</div>
                <br />
                <p>{{ `documentation.sitebar.tips_description` | t }}</p>
                <br />
              </v-row>
            </v-card-text>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex md10>
        <v-flex md12 class="mt-3">
          <v-flex d-flex md12>
            <v-flex>
              <div class="headline tw-txt-color-primary ml-3 mb-3 subtitol rounded-tabs-sub">{{ 'documentation.subtitle' | t }}</div>
            </v-flex>
          </v-flex>

          <v-flex d-flex md12 class="mt-3 ml-3">
            <v-flex v-if="failed">DOCUMENTATION NOT FOUND</v-flex>
            <v-flex v-else>
              <v-card class="elevation-0" v-on:language="getData()">
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex md3>
                      <v-list id="menu">
                        <v-list-tile @click="getItem(item.url)" v-for="item in list" ripple v-bind:key="item.id">
                          <v-list-tile-action>
                            <v-icon :color="item.url === pageurl ? 'primary' : 'grey'">label</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <h4 class="mt-2">{{ item.title }}</h4>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                    </v-flex>
                    <v-flex md8 class="ml-5">
                      <div class="markdown" v-html="content"></div>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-flex>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['type'],
  created() {
    this.actlang = this.$i18n.locale
    this.getData()
  },
  updated() {
    if (this.actlang !== this.$i18n.locale) {
      this.actlang = this.$i18n.locale
      this.getData()
    }
  },
  data() {
    return {
      failed: false,
      actlang: 'en',
      list: [],
      content: '',
      icons: [],
      pageurl: '',
      list_icons: ['description', 'accessibility', 'info', 'swap_calls', 'done', 'get_app', 'find_in_page', 'send']
    }
  },
  methods: {
    ...mapActions(['rmKey']),
    getItem(url) {
      this.pageurl = url
      const lang = this.$i18n.locale
      const server = 'https://dashboard.trawlingweb.com/api'
      //const server = this.getServer
      this.$http.get(`${server}/documentation/${this.type}/${lang}/${url}`, this.getTokenHeader).then(datacontent => {
        this.content = datacontent.data
      })
    },
    getData() {
      const lang = this.$i18n.locale
      const server = 'https://dashboard.trawlingweb.com/api'
      //const server = this.getServer
      this.$http
        .get(`${server}/documentation/${this.type}/${lang}/list`, this.getTokenHeader)
        .then(data => {
          if (data.data.pages.length > 0) {
            this.list = data.data.pages
            this.$http
              .get(`${server}/documentation/${this.type}/${lang}/${data.data.pages[0].url}`, this.getTokenHeader)
              .then(datacontent => {
                this.pageurl = data.data.pages[0].url
                this.content = datacontent.data
              })
              .catch(() => {
                this.failed = true
              })
          }
        })
        .catch(() => {
          this.failed = true
        })
    }
  },
  computed: {
    ...mapGetters(['getServer', 'getTokenHeader'])
  }
}
</script>

<style scope>
.markdown h1 {
  /*color: #27408b;*/
  color: #792422;
}
.markdown h2 {
  margin: 30px 0 6px 0;
  /* color: #415eb4;*/
  color: #b34744;
  font-size: 19px;
  font-weight: underline;
}
.markdown h2:first-of-type {
  margin-top: 5px;
}
.markdown h3 {
  font-size: 17px;
  /* color: #607ac7;*/
  color: #ae5a57;
  margin: 10px 0 6px 0;
}
.markdown p {
  font-size: 15px;
  line-height: 17pt;
  text-align: justify;
}
.markdown ul {
  margin: 20px 0 20px 30px;
  font-size: 15px;
  line-height: 17pt;
}
.markdown code {
  padding: 15px;
  margin: 10px 0;
}
.markdown table {
  align-content: center;
  border-collapse: collapse;
  width: 90%;
  margin: 10px 0 35px 30px;
}
.markdown table td {
  margin-left: 40px;
}
.markdown table thead {
  /*background-color: #5f7dd6;*/
  background-color: #f15550;
  color: white;
}
.markdown table tbody tr td,
table thead tr th {
  padding: 5px;
}
#menu {
  background-color: inherit;
  /*color: #27408b;*/
  color: #862724;
  padding: 3px 1px;
  width: 100%;
  border: none;
  outline: none;
  text-align: left;
  transition: 0.3s;
  font-size: 15px;
}
.rounded-tabs {
  border-radius: 6px !important;
}
.rounded-tabs-sub {
  border-radius: 6px !important;
}
.tamany_titol {
  font-size: 28px !important;
  font-weight: 400;
  line-height: 20px !important;
  letter-spacing: normal !important;
  font-family: 'Roboto', sans-serif !important;
}
.tamany_titol_sitebar {
  font-size: 18px !important;
  font-weight: 400;
  line-height: 20px !important;
  letter-spacing: normal !important;
  font-family: 'Roboto', sans-serif !important;
}
.ratlla {
  height: 3px !important;
}
.subtitol {
  padding-top: 8px !important;
  padding-left: 20px !important;
  background-color: #f2f2f2 !important;
  padding-bottom: 6px !important;
}
.ratlla {
  height: 5px !important;
}
.separa_tab_init_pg {
  position: static !important;
  margin-right: 120px !important;
}
.separa_tab {
  /*padding: 6px 20px !important;*/
  position: static !important;
  margin-left: 10px !important;
  margin-right: 10px !important;
}
.clear_full {
  text-transform: none !important;
}
.text_tab {
  font-size: 20px !important;
}
.background_doc {
  /*background-color: rgb(241 85 80 / 15%) !important;*/
  background: linear-gradient(to bottom, rgb(241 85 80 / 15%), #ffffff) !important; /* De rojo a blanco */
}
.tw-txt-color-primary {
  /*color: #00ff37 !important;*/
  color: #515151 !important;
}
</style>
